/*
 HotelTest

 Tresc regulaminu dla hotel-TEST
  
 historia: 
  PM 2021-12-08 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, Theme, Typography } from '@material-ui/core';

class HotelTest extends React.Component<WithStyles<typeof styles>, any> {

    render() {
        const { classes } = this.props;
        if (document.title !== 'Warunki wynajmu') {
            document.title = 'Warunki wynajmu';
        }

        return (
            <React.Fragment>
                <Typography variant='h6' align="center"><b>WARUNKI WYNAJMU HOTEL HUBERTUS RZESZÓW</b></Typography><br />
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Strona internetowa  przeznaczona jest do rezerwacji noclegów w pokojach.</Typography></li>
                    <li>
                        <Typography variant='body2' gutterBottom style={{marginBottom: "15px"}}>Właścicielem serwisu oraz prezentowanych na stronie pokoi jest firma:</Typography>
                        <Typography variant='body2' gutterBottom>EUROMID Spółka z ograniczoną odpowiedzialnością</Typography>
                        <Typography variant='body2' gutterBottom>ul. Mickiewicza 5</Typography>
                        <Typography variant='body2' gutterBottom>35-064 Rzeszów</Typography>
                        <Typography variant='body2' gutterBottom>NIP: 8133282177</Typography>
                        <Typography variant='body2' gutterBottom>REGON: 691682062</Typography>
                        <Typography variant='body2' gutterBottom>KRS: 0000123492</Typography>
                        <Typography variant='body2' gutterBottom><a href="https://hubertus.rzeszow.pl" target="_blank" rel="noreferrer" className={classes.link}>
                            <Button
                                variant="text"
                                size="large"
                                className={`${classes.linkButton} ${classes.body2Button}`}
                            >
                                https://hubertus.rzeszow.pl
                            </Button>,
                        </a></Typography>
                        <Typography variant='body2' gutterBottom style={{marginBottom: "15px"}}>adres poczty elektronicznej: <a href={`mailto:${'recepcja@hubertus.rzeszow.pl'}`} target='_blank' className={`${classes.email}`}>{'recepcja@hubertus.rzeszow.pl'}</a> </Typography>
                        <Typography variant='body2' gutterBottom></Typography>
                    </li>
                    
                    
                    <li><Typography variant='body2' gutterBottom>Numer rachunku bankowego: 41 1140 2017 0000 4102 1301 9883</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Rezerwacji pokoi można dokonywać drogą telefoniczną, pocztą elektroniczną lub on-line za pośrednictwem serwisu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Możliwa jest płatność za rezerwację on-line, jak również w hotelu przy zameldowaniu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Operatorem płatności jest mBank.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Rezerwacji można również dokonywać przez portal rezerwacyjny <a href="https://www.booking.com/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            booking.com
                        </Button>
                    </a>.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Operatorem płatności w przypadku rezerwacji przez serwis <a href="https://www.booking.com/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            booking.com
                        </Button>
                    </a> jest ten serwis.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W hotelu akceptujemy karty płatnicze, płatność przelewem (przy wcześniejszych ustaleniach), gotówkę oraz BLIK.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Zakwaterowanie w pokojach odbywa się na podstawie rezerwacji telefonicznej, drogą elektroniczną, na miejscu lub przez portal booking.com. Przy zameldowaniu wymagany jest dokument tożsamości. Płatność wymagana jest przy zameldowaniu Gościa. Zakwaterowanie możliwe jest od godziny 14:00, wymeldowanie do godziny 12:00 ostatniego dnia pobytu. Hotel czynny jest całodobowo, a recepcjonista pozostaje do dyspozycji Gości.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W przypadku anulowania rezerwacji na jeden lub więcej dni przed przyjazdem, Gość otrzyma pełny zwrot wpłaconych środków – z wyjątkiem rezerwacji bezzwrotnych. Zwrot zostanie wykonany w ciągu maksymalnie 7 dni roboczych na wskazany rachunek bankowy. W przypadku anulowania rezerwacji na mniej niż 1 dzień przed przyjazdem, Klient zobowiązany jest do uregulowania należności w wysokości ceny za pierwszą noc hotelową.</Typography></li>
                    
                    <li><Typography variant='body2' gutterBottom>Wszelkie reklamacje powinny być zgłaszane pisemnie poprzez formularz kontaktowy na stronie <a href="https://hubertus.rzeszow.pl" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            https://hubertus.rzeszow.pl
                        </Button>
                    </a> lub mailowo na adres <a href={`mailto:${'recepcja@hubertus.rzeszow.pl'}`} target='_blank' className={`${classes.email}`}>{'recepcja@hubertus.rzeszow.pl'}</a>.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Czas odpowiedzi na reklamację wynosi do 7 dni roboczych.</Typography></li>
                </ol>
                
            
                {/* <br /><Typography align="right" gutterBottom>Dyrektor PPUH Hayduk</Typography>
                <Typography align="right" gutterBottom><b>Koralewska Monika</b></Typography> */}
            </React.Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    noMarginTop: {
        marginTop: 0,
    },
    noMarginBottom: {
        marginBottom: 0,
    },
    listItem: {
        display: 'list-item',
        marginLeft: theme.spacing(5),
    },
    listNone: {
        listStyleType: 'none'
    },
    breakSpaces: {
        whiteSpace: 'break-spaces' as 'break-spaces'
    },
    linkButton: {
        color: '#3a87ad',
        "&:hover": {
            textDecoration: "underline"
        }
    },
    h6Button: {
        padding: 0,
        fontSize: theme.typography.h6.fontSize,
        lineHeight: theme.typography.h6.lineHeight,
        letterSpacing: theme.typography.h6.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    body2Button: {
        padding: 0,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: '16px',
        letterSpacing: theme.typography.body2.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    link: {
        textDecoration: 'none',
        lineBreak: 'anywhere' as 'anywhere'
    },
    alignCenter: {
        display: 'block',
        textAlign: 'center' as 'center'
    },
    email: {
        //color: "inherit",
        color: '#3a87ad',
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
});

export default withStyles(styles)(HotelTest);
